// const giftRouter = [
//   {
//     path: '/gift',
//     name: 'Gift',
//     component: () => import('@/views/gift/giftIndex.vue')
//   },
//   {
//     path: '/gift/more',
//     name: 'GiftMore',
//     component: () => import('@/views/gift/moreGift.vue')
//   }
// ]
// export default giftRouter

const giftRouter = {
  path: '/gift',
  name: 'gift',
  meta: {
    title: '礼品兑换首页'
  },
  component: () => import('@/views/gift/index.vue'),
  children: [
    {
      path: '',
      name: 'indexpage',
      component: () => import('@/views/gift/indexpage.vue')
    },
    {
      path: 'giftinfo',
      name: 'Giftinfo',
      meta: {
        title: '礼品页'
      },
      component: () => import('@/views/gift/giftinfo.vue')
    },
    {
      path: 'giftinfo_jdyx',
      name: 'giftinfo_jdyx',
      meta: {
        title: '礼品页'
      },
      component: () => import('@/views/gift/giftinfo_jdyx.vue')
    },
    {
      path: 'more',
      name: 'More',
      meta: {
        title: '更多'
      },
      component: () => import('@/views/gift/moreGift.vue')
    },
    {
      path: 'searchResult',
      name: 'searchResult',
      meta: {
        title: '搜索结果'
      },
      component: () => import('@/views/gift/search_result.vue')
    },
    {
      path: 'giftexchange',
      name: 'giftexchange',
      meta: {
        title: '礼品兑换'
      },
      component: () => import('@/views/gift/giftexchange.vue')
    },
    {
      path: 'giftexchange_jdyx',
      name: 'giftexchange_jdyx',
      meta: {
        title: '礼品兑换'
      },
      component: () => import('@/views/gift/giftexchange_jdyx.vue')
    },
    {
      path: 'paysuccess',
      name: 'paysuccess',
      meta: {
        title: '支付成功'
      },
      component: () => import('@/views/gift/paysuccess.vue')
    }
  ]
}
export default giftRouter
